import { useCallback, useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useHealthStatus = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchHealthStatus = useCallback(async () => {
    startLoading();
    const response = await apiGet("/health", "Error al obtener estado del sistema");
    setResponse(response);
    return response?.data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchHealthStatus();
    const interval = setInterval(fetchHealthStatus, 120000);
    return () => clearInterval(interval);
  }, [fetchHealthStatus]);

  return { data, error, loading, refetch: fetchHealthStatus };
};

export default useHealthStatus;
